var _a;
import { createSlice } from '@reduxjs/toolkit';
var initialState = {
    isOpened: false,
    message: null,
};
var mobileAppModalSlice = createSlice({
    name: 'mobileAppModal',
    initialState: initialState,
    reducers: {
        showModal: function (state, action) {
            state.isOpened = true;
            state.message = action.payload.message;
        },
        closeModal: function (state) {
            state.isOpened = false;
            state.message = null;
        },
    },
});
export var showModal = (_a = mobileAppModalSlice.actions, _a.showModal), closeModal = _a.closeModal;
export var selectMobileAppModal = function (state) { return state.mobileAppModal; };
export default mobileAppModalSlice.reducer;
